import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/translation.json';
import fr from './locales/fr/translation.json';
import ar from './locales/ar/translation.json';
import es from './locales/es/translation.json';

// Swaps <html dir/lang> and the active stylesheet (rtlcss-generated .rtl.css, see
// scripts/postbuild-rtl.js) whenever the active language changes, so RTL languages
// (Arabic) mirror the layout without a page reload.
//
// Both the LTR and RTL <link> tags are present in the document from the start (injected
// into build/index.html by postbuild-rtl.js), with the inactive one marked `disabled` —
// the browser still fetches/parses a disabled stylesheet, it just doesn't apply it. So
// switching language only toggles `.disabled`, which is instant since both CSSOMs are
// already warm; no new network fetch happens at switch time, unlike the previous approach
// of rewriting `href` (which only started downloading the target stylesheet at that
// moment, causing a multi-second flash of broken layout while it loaded).
const applyDocumentDirection = (lng) => {
  const dir = i18n.dir(lng);
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;

  document.querySelectorAll("link[rel='stylesheet']").forEach((link) => {
    const href = link.getAttribute('href');
    if (!href || !href.includes('main') || !href.endsWith('.css')) return;
    const isRtlSheet = href.endsWith('.rtl.css');
    link.disabled = isRtlSheet ? dir !== 'rtl' : dir === 'rtl';
  });
};

i18n.on('languageChanged', applyDocumentDirection);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      ar: { translation: ar },
      es: { translation: es },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      caches: ['localStorage'],
    },
  })
  .then(() => applyDocumentDirection(i18n.language));

export default i18n;
